export function resolvePath(path: string) {
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    return (process.env.NEXT_PUBLIC_ENV_PREFIX || '') + path;
}
